import QuandoChamarSamu from '../components/QuandoChamarSamu'

let routes = {
    path: '/quando-chamar-o-samu',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/quando-chamar-o-samu',
            name: 'QuandoChamarSamu',
            component: QuandoChamarSamu
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/quando_chamar_samu.js